<script>
import Scroll from 'base/scroll/scroll'
import { BottomSheets } from 'bxs-ui-vue'

const SHOW_ICON_NUMBER = 5.5

export default {
  name: 'ActionSheet',
  components: {
    Scroll,
    [BottomSheets.name]: BottomSheets
  },
  filters: {},
  mixins: [],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShow: false,
      categoryList: []
    }
  },
  computed: {
    itemWidth() {
      const length = this.categoryList.length
      const num = length > SHOW_ICON_NUMBER ? SHOW_ICON_NUMBER : length
      const clientWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      return Math.floor(clientWidth / num)
    },
    categoryWidth() {
      if (!this.itemWidth || !this.categoryList.length) return
      return `${this.itemWidth * this.categoryList.length}px`
    }
  },
  watch: {
    value: {
      handler(value) {
        this.isShow = value
      },
      immediate: true
    },
    isShow(value) {
      if (value) return
      this.$emit('input', value)
    }
  },
  created() {
    this.categoryList = [1, 2, 3, 4, 5, 6]
  },
  mounted() {},
  methods: {}
}
</script>
<template>
  <bxs-bottom-sheets
    v-model="isShow"
    class="as-bottom-sheets"
    :hide-header="true"
    :use-b-scroll="false"
    :prevent-scroll-through="true"
  >
    <div class="action-sheet-wrap">
      <div class="spill-con" />
      <div class="as-main">
        <scroll
          ref="list"
          class="horizontal-wrap"
          :listen-scroll="true"
          :pullup="true"
          :scroll-x="true"
          :bounce="categoryList.length > 5"
          :data="{ str: categoryList }"
        >
          <ul
            class="horizontal-list"
            :class="{ 'list-flex': categoryList.length <= 5 }"
            :style="{ width: categoryWidth }"
          >
            <li
              v-for="(item, index) in categoryList"
              :key="index"
              class="item"
              :style="{
                width: itemWidth + 'px'
              }"
            >
              <p>{{ item }}</p>
            </li>
          </ul>
        </scroll>
      </div>
    </div>
    <div slot="footer" class="bottom-wrap">
      <a class="cancel" href="javascript:;" @click="isShow = false">取消</a>
    </div>
  </bxs-bottom-sheets>
</template>
<style lang="postcss">
.as-bottom-sheets {
  box-sizing: content-box;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .bx-sheets-content--scroll {
    overflow: visible;
  }
  .bottom-wrap {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
<style lang="postcss" scoped>
@import 'variable';

.spill-con {
  position: absolute;
  top: -30px;
  right: 0;
  width: 60px;
  height: 60px;
  background-color: #ddd;
}

.horizontal-wrap {
  .horizontal-list {
    .item {
      display: inline-block;
      font-size: 30px;
    }
  }
  .list-flex {
    display: flex;
  }
}
.bottom-wrap {
  font-size: 0;
  position: relative;
  text-align: center;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  &:before {
    position: absolute;
    background: #e5e5e5;
    content: '';
    pointer-events: none;

    transform-origin: 0 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px; /*no*/

    transform: scaleY(0.5);
  }
  .cancel {
    display: inline-block;
    font-size: 14px;
    color: #333;
    vertical-align: middle;
  }
}
</style>
